<div class="complex-list-empty">
  @switch (emptyStateType) {
    @case (emptyStateTypes.Recording) {
      <ftr-illustration [illustration]="illustration.NoRecordings"></ftr-illustration>
    }
    @case (emptyStateTypes.Transcript) {
      <ftr-illustration [illustration]="illustration.NoTranscripts"></ftr-illustration>
    }
    @case (emptyStateTypes.AuditLog) {
      <ftr-illustration [illustration]="illustration.AuditLog"></ftr-illustration>
    }
  }
  <div>
    @switch (hasAppliedFilters) {
      @case (true) {
        <p>There are no {{ entityName }} that match the result.</p>
        <p>
          You can <a href class="link" (click)="$event.preventDefault(); clearAll()">clear all filters</a> or try
          different <a href class="link" (click)="$event.preventDefault(); toggleFilters()">filters</a>.
        </p>
      }
      @case (false) {
        <p>There are no {{ entityName }} to display.</p>
      }
    }
  </div>
</div>
